export const LEAGUE_POINTS_PER_GAME = 5;
export const LEAGUE_POINTS_TO_WIN = 25;
export const MATCH_WINNING_SCORE = 7;
export const PLACE_COLORS = { 1: "#FFD700", 2: "#C0C0C0", 3: "#CD7F32" };